import { useContext } from "react";

import { AppConfigContext } from "../../../../core/configuration/Configuration";
import { useAuthorizedFetch } from "../../../../core/data-access/useAuthorizedFetch";
import { GetStorageProfileLookupResponse } from "./GetStorageProfileLookupResponse";

export const useStorageProfileApi = () => {
    const appConfigContext = useContext(AppConfigContext);
    const baseUrl = `${appConfigContext.ordersConfig.apiUrl}/signiant/storage-profiles`;

    const { httpGet } = useAuthorizedFetch();

    const getStorageProfiles = async (): Promise<GetStorageProfileLookupResponse> => {
        return httpGet<GetStorageProfileLookupResponse>(`${baseUrl}/get-lookup`);
    };

    return {
        getStorageProfiles
    };
};
